module.exports = __webpack_public_path__ + "static/thumbnail-winebox-8ee3f5a85cb7cfb2ad6d2adc25e0bb5a.jpg";